import { generateUUID } from '@/utils/other';
import httpRequest from '@/utils/request';

type ICommentInfo = IComment.IResponse.ICommentInfo;
type ICreateOrUpdateComment = IComment.IRequest.ICreateOrUpdateComment;

type IModuleType =
  | 'Issue'
  | 'Module'
  | 'Payment'
  | 'Quotation'
  | 'Requirement'
  | 'Todo';

export const createCommentUrl = (moduleType: IModuleType, mId: string) => {
  return `/${moduleType}/${mId}/comment`;
};
const generateUrlById = (commentId: string): string => {
  return `/Comment/${commentId}`;
};

const updateComment = (url: string, comment: ICreateOrUpdateComment): Promise<IResponseData.IBaseData> => {
  return httpRequest.post(url, comment);
};

const deleteComment = (commentId: string): Promise<IResponseData.IBaseData> => {
  return httpRequest.delete(generateUrlById(commentId));
};

export const requestUpdateComment = (url: string, comment: ICreateOrUpdateComment): Promise<string> => {
  const isCreate = comment.id ? false : true;
  return new Promise((reslove, reject) => {
    if (isCreate) {
      comment.id = generateUUID();
    }
    updateComment(url, comment).then((res) => {
      reslove(res.message);
    }).catch((error) => {
      reject(error.message);
    });
  });
};

export const requestDeleteComment = (commentId: string): Promise<string> => {
  return new Promise((reslove, reject) => {
    deleteComment(commentId)
      .then((res) => {
        reslove(res.message);
      })
      .catch((error) => {
        reject(error.message);
      });
  });
};

export const sortCommentList = (commentList: ICommentInfo[]) => {
  const result: ICommentInfo[] = commentList.slice();
  return result.sort((commentA, commentB) => {
    const a = new Date(commentA.createdOn).valueOf();
    const b = new Date(commentB.createdOn).valueOf();
    return b - a;
  });
};
